import Cookies from 'js-cookie';
import qs from 'query-string';

export type UTMParameters = {
  utmCampaign: string;
  utmContent: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
};

export const getUTMParameters = (): UTMParameters => {
  const UTMCookie = Cookies.get('utm_params');
  let utmParams: Record<string, string> | undefined;

  try {
    utmParams = JSON.parse(`${UTMCookie}`);
  } catch {
    utmParams = undefined;
  }

  const URLquery = qs.parse(window.location.search);

  return {
    utmSource: (URLquery.utm_source as string) ?? utmParams?.['utm_source [last touch]'] ?? '',
    utmMedium: (URLquery.utm_medium as string) ?? utmParams?.['utm_medium [last touch]'] ?? '',
    utmCampaign: (URLquery.utm_campaign as string) ?? utmParams?.['utm_campaign [last touch]'] ?? '',
    utmContent: (URLquery.utm_content as string) ?? utmParams?.['utm_content [last touch]'] ?? '',
    utmTerm: (URLquery.utm_term as string) ?? utmParams?.['utm_term [last touch]'] ?? '',
  };
};
